module.exports = __webpack_public_path__ + "static/media/BasisGrotesque-Regular.68aebbbe.woff2";